export default __webpack_public_path__ + "static/media/at-sign-icon.19ced4d2.svg";